<template>
    <div
        v-if="forceDisplay || timezone !== 'Asia/Tokyo'"
        class="vc-timezone-box u-palt">
        <span class="small">
            {{ helper.dateForHuman(format, timezone) }}
        </span>
        <span
            class="small font-weight-bold"
            :class="helper.dayForHumanCSS(format , timezone)">
            {{ helper.dayForHuman(format, timezone, { bracket: true }) }}
        </span>
        <span class="small">
            {{ helper.timeForHuman(format , timezone) }}
        </span>
        <div class="small">
            {{ `${helper.getOffsetFromUTC(timezone)} ${timezone}` }}
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'

    /**
     * 患者タイムゾーン併記（汎用）
     * component
     */
    export default  {
        name: 'TimezoneBoxCommon',

        props: {
            format: {
                type: String,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            forceDisplay: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
            }
        },
    }
</script>

<style scoped lang="scss">
    .vc-timezone-box {
        margin-top: 4px;
        padding: 4px 6px;
        font-size: 10px;
        line-height: 1.4;
        background-color: rgb(230, 230, 230);
        border-radius: 3px;
    }
</style>
